var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link, useParams } from "react-router-dom";
export default function DropdownList(_a) {
    var item = _a.item;
    var type = useParams().type;
    return (_jsx("div", __assign({ className: " grid grid-cols-3 max-h-[50vh] overflow-auto p-6" }, { children: item &&
            Object.values(item).map(function (dropdown, index) { return (_jsx("div", __assign({ className: "text-sm" }, { children: _jsx(Link, __assign({ to: "/modules/ModuleBuilder/".concat(type, "/lists/").concat(dropdown.name), className: "block py-1 text-[rgb(var(--color-gray-700))] hover:text-[rgb(var(--color-blue-800))]" }, { children: dropdown.name })) }), index)); }) })));
}
